import { createI18n } from 'vue-i18n';
import { en } from '@/localisation/en';
import { nl } from '@/localisation/nl';

const user = JSON.parse(localStorage.getItem('user') || '{}');
const initialLocale = user.locale || 'nl';

export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: initialLocale,
  fallbackLocale: 'en',
  messages: { en, nl },
});

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.use(i18n);
});